export default "__VITE_ASSET__AcIVowZr__"